var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIxExploreFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7623 5.315L16.7335 12.881L15.285 13.307L18.2501 21.1899L16.3775 21.8922L13.361 13.873L12.005 14.271L9.20834 21.8929L7.37005 21.105L9.62 14.973L3.76888 16.6943L2 13.1565L13.7623 5.315ZM18.7348 2L22.6521 11.1404L18.6597 12.3145L15.4652 4.17973L18.7348 2Z",
    fill: "#8494AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIxExploreFilled);
export default __webpack_public_path__ + "static/media/ix_explore-filled.af02f0e2121ec9a0bfb867d6e5ba009f.svg";
export { ForwardRef as ReactComponent };